import { Capacitor } from '@capacitor/core'

/**
 * Check if running as native iOS app (via Capacitor)
 * Used to conditionally disable payment features during Phase I
 *
 * TEMPORARY: Phase I iOS restriction - Remove in Phase II
 * See: docs/PHASE_I_TEMPORARY_IOS_RESTRICTIONS.md
 */
export function isIOSApp(): boolean {
    return Capacitor.getPlatform() === 'ios' && Capacitor.isNativePlatform()
}

/**
 * Check if running in web browser (not a native app)
 */
export function isWebPlatform(): boolean {
    return !Capacitor.isNativePlatform()
}

/**
 * Get current payment provider based on platform
 *
 * TEMPORARY: Phase I iOS restriction - Remove in Phase II
 * Returns 'disabled' for iOS, 'stripe' for web
 */
export function getPaymentProvider(): 'stripe' | 'disabled' {
    return isIOSApp() ? 'disabled' : 'stripe'
}

/**
 * Check if payments are enabled on current platform
 *
 * TEMPORARY: Phase I iOS restriction - Remove in Phase II
 * Returns false on iOS, true on web
 */
export function arePaymentsEnabled(): boolean {
    return !isIOSApp()
}
